import { MenuItem, Select, styled } from "@mui/material";

export const BybSelect = styled(Select)(
  ({ theme, size = 'large' }) => `
    .MuiSelect-select {
        color: ${theme.palette.dsBase.v200};
        font-family: ${theme.typography.fontFamily};
        font-size: ${size === 'large' ? theme.typography.text1xl400.fontSize : theme.typography.textBase500.fontSize};
        line-height: ${size === 'large' ? theme.typography.text1xl400.lineHeight : theme.typography.textBase500.lineHeight};
        background-color: ${theme.palette.dsSurface.v100};
        border-radius: ${size === 'large' ? '20px' : '12px'};
        border-style: none;
        padding-left: ${size === 'large' ? '20px' : '12px'};
        padding-right: ${size === 'large' ? '20px' : '12px'};
    }

    .MuiSelect-select:focus {
        border-radius: ${size === 'large' ? '20px' : '12px'};
    }

    & .MuiOutlinedInput-notchedOutline {
        border-style: none;
    }

    & .MuiSelect-iconOutlined {
        right: ${size === 'large' ? '12px' : '8px'};
    }
`
);

export const BybMenuItem = styled(MenuItem)(
  ({ theme }) => `
    color: ${theme.palette.dsBase.v200};
    font-family: ${theme.typography.fontFamily};
    font-size: ${theme.typography.text1xl400.fontSize};
    line-height: ${theme.typography.text1xl400.lineHeight};
    height: 64px;
`
);